// 首页的接口
import request from '../utils/request'

// 获取所有的市/获取机构类型

export function getCityList(data) {
  return request({
    url: '/sc/system/api/sysDictionary/getChildDictByListCode',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 查询服务类型

export function getServiceType(data) {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/home/queryFwlxStatistics',
    method: 'get',
    params: data
  })
}

// 获取服务下的区划
export function getServiesQhList(data) {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/home/queryFwqhStatistics',
    method: 'get',
    params: data
  })
}

// 获取服务下的区划的列表
export function getServiesList(data,isToken = false) {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/home/page',
    method: 'get',
    params: data,
    headers: {
      isToken: isToken
    }
  })
}

//分页查机构数据
export function getOrgList(data) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/home/page',
    method: 'get',
    params: data
  })
}

// 获取服务下的区划的列表
export function getServiesListLoading(data, isToken = false) {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/home/page',
    method: 'get',
    params: data,
    isShowLoader: false,
    headers: {
      isToken: isToken
    }
  })
}

//分页查机构数据
export function getOrgListLoading(data,isToken = false) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/home/page',
    method: 'get',
    params: data,
    isShowLoader: false,
    headers: {
      isToken: isToken
    }
  })
}

// 领券
export function getCoupon(data) {
  return request({
    url: '/sc/ticketMain/api/factQylq/getCoupon',
    method: 'post',
    data,
    headers: {
      isToken: true
    }
  })
}

// 下载文件模板
export function downloadFileTemplateManage(id) {
  return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/system/api/sysFileTemplateManage/downloadTemplate/' + id
}

// 预览文件模板
export function previewFileTemplateManage(id) {
  return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/system/api/sysFileTemplateManage/previewTemplate/' + id
}

//常见问题列表
export function getFactWtxxList(params) {
  return request({
    url: '/sc/ticketMain/api/factWtxx/page',
    method: 'get',
    params: params
  })
}

//常见问题详情
export function getFactWtxxDetail(params) {
  return request({
    url: '/sc/ticketMain/api/factWtxx/detail',
    method: 'get',
    params: params
  })
}

//工作动态列表
export function getFactGsxxList(params) {
  return request({
    url: '/sc/ticketMain/api/factGsxx/page',
    method: 'get',
    params: params
  })
}

//工作动态详情
export function getFactGsxxDetail(params) {
  return request({
    url: '/sc/ticketMain/api/factGsxx/detail',
    method: 'get',
    params: params
  })
}

// 服务详情
export function getFactFwjbxxbDetail(params) {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/home/detail',
    method: 'get',
    params: params
  })
}

// 首页统计
export function getFactHomeStatisticsDetail(params) {
  return request({
    url: '/sc/ticketMain/api/factHomeStatistics/detail',
    method: 'get',
    params: params
  })
}

// 获取最新创新券
export function getNewCxq() {
  return request({
    url: '/sc/ticketMain/api/factEdgl/home/detail',
    method: 'get'
  })
}

// 判断当前用户是否领券
export function getIsExistQylq() {
  return request({
    url: '/sc/ticketMain/api/factQylq/isExistQylqRecord',
    method: 'get',
    headers: {
      isToken: true
    }
  })
}

// 识别发票接口信息
export function getInvoiceInfo(data) {
  return request({
    url: process.env.VUE_APP_FPSB_API,
    method: 'post',
    data,
    headers: {
      isToken: false,
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 识别银行回单接口信息
export function getInvoiceInfoYhHd(data) {
  return request({
    url: process.env.VUE_APP_YHHD_API,
    method: 'post',
    data,
    headers: {
      isToken: false,
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 识别合同登记接口信息
export function getInvoiceInfoHtDj(data) {
  return request({
    url: process.env.VUE_APP_HTDJ_API,
    method: 'post',
    data,
    headers: {
      isToken: false,
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 企业兑付-企业申报开关
export function getDfEnable(data) {
  return request({
    url: '/sc/system/api/sysDictionary/getDictByCode',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}
